/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { Translated } from 'utils/staticText';
import { RewardCopyrightText } from './i18n';

export function RewardCopyright(props: {
  staticText: Translated<typeof RewardCopyrightText>;
}): JSX.Element {
  return (
    <section className="flex flex-col items-center gap-[--spacing-gap-y] self-stretch border-t border-t-[--borders-default] pt-[--spacing-gap-y] md:pt-[--spacing-gap-section-y]">
      <div className="mhg-alpha-caption text-[--text-disabled]">
        {props.staticText.copyright}
      </div>
    </section>
  );
}
